<template>
  <div style="position:relative; min-height: 250px">
    <transition name="fade">
      <Spin size="large" fix v-if="showProgress">
        <Icon type="load-c" size=18 class="demo-spin-icon-load"></Icon>
        <div>Processing answer...</div>
      </Spin>
      <div v-else-if="hasAnswered" >
        <div class="show" >
          <canvas ref="myChart" id="myChart"   />
          <div class="center-image shadow" v-bind:style="{ backgroundImage: 'url(' + profileInfo.avatar + ')' }">&nbsp;</div>
        </div>
        <div class="poll-selection poll-results selected ivu-radio-group ivu-radio-group-vertical ">
          <div class="ivu-radio-wrapper ivu-radio-group-item" v-for="(item, itemIndx) in pollItem.choices" :key="itemIndx" v-if="item.text">
            <span class="legend" :style="{
              background: backgroundColor[itemIndx],
              borderColor: borderColor[itemIndx] ,
              borderWidth: userType !== 'guest' && (isMyAnswer(item.id)) ? '1px' : '1px'}"></span>
            <span :style="{fontWeight: (isMyAnswer(item.id)) ? 'bold': 'initial'}">{{item.text}}
              <!-- <span class="sub-text-total">{{(isMyAnswer(item.id)) ? ' (Your answer)':''}}</span> -->
              <img :src="profileInfo.avatar" class="shadow" v-if="isMyAnswer(item.id)" :style="{  borderRadius: '50%', width: '16px', height: '16px', verticalAlign: 'middle', display: 'inline-block'}" />
            </span>
          </div>
        </div>
        <div  >
          <p class="sub-text-total">Total votes: <b>{{resultCount}}</b></p>
          <p v-if="pollItem.result_info.length>0" style="padding-top:10px"><small>More Info: {{pollItem.result_info}}</small></p>
        </div>
      </div>
      <div v-else class="poll-selection poll-choices" >
        <RadioGroup  class="radio-selection" vertical  v-model="choice" @on-change="getSelectedChoice">
          <Radio v-for="(item,itemIndx) in pollItem.choices" :key="itemIndx" :label="item.text" v-if="item.text">
            {{item.text}}
          </Radio>
        </RadioGroup>
        <transition name="fade">
          <div v-if="!isDisabled" class="action-buttons">
              <Button @click="submitAnswer()" type="primary">Submit</Button>
          </div>
        </transition>
      </div>
    </transition>
  </div>
</template>

<script>
import TransitionExpand from '@/lib/TransitionExpand';
import Chart from 'chart.js'
import 'chart.piecelabel.js';
import Vue from 'vue'
import * as Colors from '@/helpers/color'

export default {
  name: 'PollComponent',
  components: {
    TransitionExpand,
  },
  props: {
    pollItem: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      choice_id: null,
      choice: '',
      showProgress: false,
      hasAnswered: false,
      isDisabled: true,
      backgroundColor: Colors.arrayOfColorsAsString(['red', 'blue', 'modifiedYellow', 'purple', 'green'], 0.4),
      borderColor: Colors.arrayOfColorsAsString(['red', 'blue', 'modifiedYellow', 'purple', 'green'],1),
      chartData: []
    }
  },
  mounted() {
    this.loadPollAnswer().then(() => {
      this.loadPollResult()
    })
  },
  beforeDestroy() {
    if(this.$chrt) {
      this.$chrt.destroy();
    }
  },
  methods: {
    isMyAnswer(id) {
      return (this.pollAnswer[0] && (id === this.pollAnswer[0].answer_id));
    },
    getPercentage(id) {
      let count = 0;
      for (var i=0; i < this.pollResult.length; i++) {
        if (this.pollResult[i].id === id) {
          count = this.pollResult[i].result;
        }
      }
      return Math.floor(((count / this.resultCount) * 100));
    },
    getVoterCount(id) {
      let count = 0;
      for (var i=0; i < this.pollResult.length; i++) {
        if (this.pollResult[i].id === id) {
          count = this.pollResult[i].result;
        }
      }
      return (count == 1) ? count + " Vote" : count + " Votes";
    },
    getSelectedChoice(v) {
      this.choice_id = _.find(this.pollItem.choices, { 'text': v }).id;
      if (this.userType !== 'guest') { // marked
        this.isDisabled = !(v);
      } else {
        this.$store.commit('hitCheckpoint')
      }
    },
    loadPollResult () {
      return this.$store.dispatch('answer/getPollResult', this.pollItem.item_id)
      .then(() => {
        if (this.hasAnswered)
          Vue.nextTick(() => {
            this.prepareCharts()
            this.updateChartData()
          }, 500)
      })
    },
    loadPollAnswer () {
      return this.$store.dispatch('answer/getPollAnswer', this.pollItem.item_id).then(
        res => {
          this.hasAnswered = this.isAnswered && this.userType !== 'guest' // marked
        });
    },
    submitAnswer() {
      this.showProgress = true
      this.$store.dispatch('answer/postPollAnswer', {
        itemId: this.pollItem.item_id,
        answer_id: this.choice_id,
        answer: this.choice
      }).then(res => {
        this.isDisabled = true

        // this.$Message({
        //   closable: true,
        //   // durationInSec:3,
        //   title: { content:'Submitted' },
        //   icon: 'checkmark',
        //   message: { content: 'Answer submitted.' },
        //   buttons: [
        //     { label: 'Ok', type: 'primary', hideAfter:true, action: ()=> next() }
        //   ]
        // });    

        this.loadPollAnswer().then(() => {
          this.hasAnswered = true;
          this.showProgress = false
          this.loadPollResult()
        })
      })
    },
    updateChartData() {

      let result = this.pollResult.filter(r => r.text)
      let labels = result.map(r => r.text)
      let data = result.map(r => r.result)
      if (this.$chrt === undefined)
        return

      this.$chrt.data.labels = labels
      this.$chrt.data.datasets.forEach((dataset) => {
        dataset.data = data
      });
      this.$chrt.update()


    },
    prepareCharts() {
      let ctx = this.$refs.myChart

      this.$chrt = new Chart(ctx, {
        type: 'doughnut',
        data: {
          labels: [],
          datasets: [{
            data: [],
            backgroundColor: this.backgroundColor,
            borderColor: this.borderColor,
            borderWidth: 1
          }]
        },
        options: {
          pieceLabel: [
            {
              render: 'percentage',
              fontColor: '#000',
              fontSize: 14,
              fontStyle: 'bold',
              overlap: true
            }
          ],
          legend: {
            display: false,
            position: 'left',
            labels: {
              boxWidth: 12
            }
          },
          tooltips: {
              enabled: true,
              mode: 'single',
              // callbacks: {
              //     label: function(tooltipItems, data) {
              //       let label = data.labels[tooltipItems.index]
              //       let value = data.datasets[tooltipItems.datasetIndex].data[tooltipItems.index]
              //       return `${label}: ${value}%`;
              //     }
              // }
          },
          scales: {
            xAxes: [{
              display:false,
              gridLines: {
                  display:false,
                  drawBorder: false,
              },
            }],
            yAxes: [{
              display:false,
              gridLines: {
                  display:false,
                  drawBorder: false
              }
            }]
          },
        }
      })
    },
  },
  computed: {
    resultCount: {
      get() {
        let count = 0;
        for (var i=0; i < this.pollResult.length; i++) {
          count += parseInt(this.pollResult[i].result);
        }
        return count;
      }
    },
    labels: {
      get() {
        return this.pollItem.choices.filter(choice => choice.text).map(choice => choice.text )
      }
    },
    pollResult: {
      get() {
        return this.$store.state.answer.pollResult;
      }
    },
    pollAnswer: {
      get() {
        return this.$store.state.answer.pollAnswer;
      }
    },
    userType: {
      get() {
        return this.$store.state.user.info.user_type;
      }
    },
    isAnswered: {
      get() {
        return !(_.isEmpty(this.pollAnswer));
      },
      set(v) {
        this.hasAnswered = v;
      }
    },
    profileInfo: {
      get() {
        return this.$store.state.user.info;
      }
    }
  }
}
</script>

<style scoped>
.selected.ivu-radio-group-vertical .ivu-radio-wrapper {
 cursor:unset;
}
.legend {
  width: 14px;
  height: 14px;
  display:inline-block;
  vertical-align: middle;
  border-style: solid;
  border-width: 1px;
  margin-right: 4px;
  white-space: nowrap;
  position: relative;
  line-height: 1;
  /* border-radius: 50%; */
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>

<style scoped>
label.ivu-radio-wrapper.ivu-radio-group-item {
  border: none;
}
.ivu-radio-wrapper.ivu-radio-group-item,
.ivu-checkbox-wrapper{
  display: block;
  margin:8px 0;
}
.action-buttons {
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid #ddd;
  padding-top: 10px;
}
.sub-text {
  color: #9c9c9c;
  font-size: 11px;
}
.sub-text-total {
  color: #9c9c9c;
  font-size: 11px;
  padding-top: 5px;
  text-align: center;
}
.show{
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
<style>
.poll-selection {
  padding:0 16px;
}
.poll-results .ivu-progress-show-info .ivu-progress-outer {
  padding-right: 0;
  margin: 8px 0 0 0;
}
.poll-results .ivu-progress-inner {
  border-radius: 0;
}
.poll-results .ivu-progress-bg {
  border-radius: 0;
}
.poll-results .ivu-progress-text {
  margin-left: 0;
  width: 100%;
    /* display: inline-block;
    margin-left: 5px;
    text-align: left;
    font-size: 1em;
    vertical-align: middle;
    float: left;
    position: absolute;
    z-index: 1;
    top: 0;
    right: 0;
    line-height: 26px;
    padding-right: 10px;
    margin: 5px 0 0 0;
    font-size: 11px; */
}

.center-image {
  z-index:9;
  position: absolute;
  width: 20%;
  height: 40%;
  border-radius: 50%;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  background-position: center;
}

.shadow {
   box-shadow: 2px 1px 10px rgba(0, 0, 0, .5);
}


</style>
